import React from 'react';
import { v4 as uuidv4 } from 'uuid';

const AppContext = React.createContext([null, _ => {}]);

export const AppProvider = ({ children }) => {
  const [ownershipHash, setOwnershipHash] = React.useState('');
  const [saleCalendarViewData, setSaleCalendarViewData] = React.useState({}); // obecny widok, ośrodek i przedział dni

  React.useEffect(() => {
    setOwnershipHash(uuidv4());
  }, []);

  return (
    <AppContext.Provider value={
      { ownershipHash, setOwnershipHash, saleCalendarViewData, setSaleCalendarViewData }}>
      {children}
    </AppContext.Provider>
  );
};

export default AppContext;

export const useApp = () => React.useContext(AppContext);
